import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import console from "../utils/functions/console";
import { RESPONSE_HEADER } from "../utils/enums";
import { sendError } from "../utils/functions";
import LieferadressenStorage from "../storage/lieferadressen-storage";

export const fetchLieferadressen = createAsyncThunk("lieferadressen/fetchLieferadressen", ({ apiCall }, _trunkApi) => {
  if (typeof apiCall !== "function") return Promise.reject(new Error("invalid api call lieferadressen/fetchLieferadressen"));
  return new Promise((resolve, reject) => {
    try {
      apiCall((error, data, response) => {
        if (response && data && !error) {
          if (data.header && data.header.status === RESPONSE_HEADER.STATUS.SUCCESSFUL) {
            resolve(data);
          } else if (data.header && data.header.errorNr) {
            reject(new Error("Fehler " + data.header.errorNr + ": Die Liste der Lieferadressen konnte nicht ermittelt werden"));
          } else {
            reject(new Error("Bei der Ermittlung der Lieferadressen ist ein Fehler aufgetreten"));
          }
        } else {
          console.error(error);
          reject(new Error("Die Lieferadressenliste konnten nicht geladen werden"));
        }
      });
    } catch (e) {
      console.error(e);
      reject(e);
    }
  });
});

export const updateLieferadresse = createAsyncThunk("lieferadressen/updateLieferadresse", ({ apiCall, adresse }, _trunkApi) => {
  if (typeof apiCall !== "function") return Promise.reject(new Error("invalid api call auftrag/setAction"));
  return new Promise((resolve, reject) => {
    try {
      apiCall({ ...adresse }, (error, data, response) => {
        if (response && data && !error) {
          if (data.header && data.header.status === RESPONSE_HEADER.STATUS.SUCCESSFUL) {
            resolve({ data });
          } else {
            if (data.header && data.header.status === RESPONSE_HEADER.STATUS.ERROR) {
              if (RESPONSE_HEADER.ERROR[data.header.errorNr]) {
                reject(new Error(RESPONSE_HEADER.ERROR[data.header.errorNr]));
              } else if (data.header.errorMsg) {
                reject(new Error(data.header.errorMsg));
              } else {
                reject(new Error(RESPONSE_HEADER.ERRORTITEL.UNBEKANNT));
              }
            } else {
              reject(new Error("Es ist ein unbekannter Fehler aufgetreten"));
            }
          }
        } else {
          console.error(error);
          reject(new Error("Die Lieferadresse konnten nicht geändert werden"));
        }
      });
    } catch (e) {
      console.error(e);
      sendError(e);
      reject(e);
    }
  });
});

const lieferadressenSlice = createSlice({
  name: "lieferadressen",
  initialState: new LieferadressenStorage(),
  reducers: {
    getListe(state, action) {
      state.setListe(action.payload);
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchLieferadressen.pending, (state) => {
        state.failed(null);
        state.loading(true);
        return state;
      })
      .addCase(fetchLieferadressen.fulfilled, (state, action) => {
        let res = action.payload;
        state.setListe(res.lieferadressenListe);
        state.loading(false);
        return state;
      })
      .addCase(fetchLieferadressen.rejected, (state, action) => {
        state.failed(action.error);
        state.setListe([]);
        state.loading(false);
        return state;
      })
      .addCase(updateLieferadresse.pending, (state) => {
        state.failed(null);
        state.updating(true);
        return state;
      })
      .addCase(updateLieferadresse.fulfilled, (state, action) => {
        state.updateAdresse(action?.meta?.arg?.adresse);
        state.updating(false);
        return state;
      })
      .addCase(updateLieferadresse.rejected, (state, action) => {
        state.failed(action.error);
        state.updating(false);
        return state;
      })
  }
});
export const { getListe } = lieferadressenSlice.actions;
export const auftragActions = lieferadressenSlice.actions;
export default lieferadressenSlice.reducer;
